import { Injectable } from '@angular/core';
import { Http, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/Rx';
import { URL_SERVICIOS } from '../../conf/url.servicios';
import { Router } from '@angular/router';
import { ConsultaService } from '../services/consulta.service';



@Injectable()
export class ProductosService {
  constructor(private router: Router, public http: Http, private consultaService: ConsultaService) { }
  productos: any = [];
  idProducto: any;
  categoria: any = {};
  imagenes: any = [];

  eliminarProducto(paramId) {

    console.log("::: Blog eliminaBlog service ");
    var obj: any = {};
    if (this.consultaService.esNuevaSession) {
      obj.N_ID = paramId
      obj.idUsuario = localStorage.getItem("paramId");
      obj.token = localStorage.getItem("paramToken");
      console.log(obj);
      //console.log(paramBlog);
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/productos/eliminarProducto';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, obj, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            //console.log(data);
            resolve(true);
          })
      });
      return promesa;
    }
  }

  guardaRelacionImgProducto(paramRel: any): any {
    if (this.consultaService.esNuevaSession) {
      paramRel.idUsuario = localStorage.getItem("paramId");
      paramRel.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/productos/guardaRelacionProductoImg';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramRel, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            resolve(true);
          })
      });
      return promesa;
    }
  }
  guardarProducto(paramProducto): any {
    console.log("Producto a guardar");
    console.log(paramProducto);
    if (this.consultaService.esNuevaSession) {
      paramProducto.idUsuario = localStorage.getItem("paramId");
      paramProducto.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/productos/guardaProducto';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramProducto, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            this.idProducto = data.idFinal;
            resolve(true);
          })
      });
      return promesa;
    }
  }

  actualizarProducto(paramProducto: any): any {
    if (this.consultaService.esNuevaSession) {
      paramProducto.idUsuario = localStorage.getItem("paramId");
      paramProducto.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {

        console.log("Item to updtae")
        console.log(paramProducto);

        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/productos/actualizaProducto';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramProducto, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              resolve(true);
            }

          })
      });
      return promesa;
    }

  }


  /**
   * Obtiene una lista de blogs
   */
  obtieneProductos(idCategoria: any) {
    console.log('idCategoria', idCategoria);
    let promesa = new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + '/productos/obtieneListaProductos/' + idCategoria;
      this.http.get(url)
        .map(resp => resp.json())
        .subscribe(data => {
          this.productos = data.resultado;
          console.info("::: obtieneProductos :::");
          console.info(this.productos);
          resolve(true);
        });
    });
    return promesa;

  }


  /**
   * Obtiene una categoría
   */
  obtieneCategoria(idCategoria: any) {

    let promesa = new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + '/categorias/obtieneCategoria/' + idCategoria;
      this.http.get(url)
        .map(resp => resp.json())
        .subscribe(data => {
            this.categoria={};
          this.categoria = data.resultado;
          console.info("::: obtieneCategoria :::");
          resolve(true);
        });
    });
    return promesa;

  }

  /**
   * Obtiene una lista de imagenes del Producto
   */
  obtieneImagenes(idProducto: any) {
    console.log('idProducto', idProducto);
    let promesa = new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + '/productos/obtieneListaImgProductos/' + idProducto;
      this.http.get(url)
        .map(resp => resp.json())
        .subscribe(data => {
          this.imagenes = data.resultado;
          console.info("::: obtieneImagenes :::");
          console.info(this.imagenes);
          resolve(true);
        });
    });
    return promesa;

  }


  /**
  Eliminar ImgSecProducto
  */
    eliminarImgSecProducto(paramImgSecProducto: any) {
      console.log("::: Blog eliminaBlog service ");
      if (this.esNuevaSession) {
        paramImgSecProducto.idUsuario = localStorage.getItem("paramId");
        paramImgSecProducto.token = localStorage.getItem("paramToken");

        //console.log(paramBlog);
        let promesa = new Promise((resolve, reject) => {
          let data = new URLSearchParams();
          let url = URL_SERVICIOS + '/productos/eliminarImgSecProducto';
          let headers = new Headers({
            'Content-Type': 'application/json'
          })
          this.http.post(url, paramImgSecProducto, { headers })
            .map(resp => resp.json())
            .subscribe(data => {
              //console.log(data);
              resolve(true);
            })
        });
        return promesa;
      }
    }


    esNuevaSession(): any {
      var nueva = false;
      if (localStorage.getItem("paramId") == null || localStorage.getItem("paramId") == '') {
        nueva = true;
        this.goLogin();
      }
      console.log("Es nueva sesion " + nueva);
      return nueva;
    }


    goLogin(): any {
      $("#btn_open_modal_perfiles").click();
      this.router.navigate(['/home']);
    }


}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/services/productos.service.ts